<template>
  <div class="font-readex" style="font-weight: 400 !important;">
    <v-alert v-if="creditError" type="error">Nedostatek kreditu</v-alert>
    <v-alert v-if="serverError" color="error">Chyba serveru.</v-alert>
          <v-card
            class="mx-auto"
          >
            <v-container id="last-info">
              <v-row>
                <v-col
                  class=""
                  cols="6"
                >
                  <v-card-text>
                    <h2 class="heading text--primary">
                      Fakturační údaje
                    </h2><br>
                    <div class="text--primary">
                      <p>{{ cart.user ? cart.user.companyName : '' }}</p>
                      <p>IČO: {{ cart.user ? cart.user.ico : '' }}</p>
                      <p>DIČ: {{ cart.user ? cart.user.dic : '' }}</p>
                      <!-- prazdne stringy, pokud neni zvoleny uzivatel - haze vue errory -->
                      <p>{{ cart.user ? cart.user.fullName : '' }}</p>
                      <p>{{ cart.user ? cart.user.street : '' }} {{ cart.user ? cart.user.streetNumber : '' }},
                        {{ cart.user ? cart.user.city : '' }} {{ cart.user ? cart.user.zip : '' }}</p>
                      <p>{{ cart.user ? cart.user.email : '' }}</p>
                    </div>
                  </v-card-text>
                </v-col>
                <v-col
                  class=""
                  cols="6"
                >
                  <v-card-text>
                    <div class="d-flex flex-wrap">
                      <h2
                        class="heading text--primary align-self-center"
                        style="margin-right: 15px"
                      >
                        Dodací údaje
                      </h2>
                      <v-btn
                        v-if="cart.diet.dietType !== 'Instituční'"
                        @click="changeAddress"
                        text
                        style="margin-left: -15px"
                      ><v-icon small color="green darken-1">
                        mdi-pencil
                      </v-icon>
                        Upravit jednorázově
                      </v-btn>
                    </div>
                    <br>
                    <div class="text--primary">
                      <p>{{ cart.user ? deliveryInfo.name : '' }}</p>
                      <p>{{ cart.user ? deliveryInfo.street : '' }}
                        {{ cart.user ? deliveryInfo.streetNumber : '' }},
                        {{ cart.user ? deliveryInfo.city : '' }} {{ cart.user ? deliveryInfo.zip : '' }}</p>
                      <p>{{ cart.user ? cart.user.email : '' }}</p>
                    </div>
                    <v-dialog
                      v-model="editDeliveryDialog"
                      max-width="650"
                    >
                      <v-card>
                        <v-card-title>Upravit dodací údaje</v-card-title>
                       <v-form
                       ref="form"
                       v-model="formValid"
                       >
                         <v-card-text>
                           <v-container>
                             <v-alert
                               v-if="!formValid"
                               border="top"
                               color="red"
                               dark
                             >
                               Vyplňte prosím všechna pole
                             </v-alert>
                             <v-row>
                               <v-col cols="8">
                                 <v-text-field
                                   outlined
                                   label="Adresa"
                                   v-model="editedAddressData.street"
                                   required
                                   hide-details
                                   :rules="[rules.required]"
                                 ></v-text-field>
                               </v-col>
                               <v-col cols="4">
                                 <v-text-field
                                   outlined
                                   label="č.p."
                                   v-model="editedAddressData.number"
                                   required
                                   hide-details
                                   :rules="[rules.required]"
                                 ></v-text-field>
                               </v-col>
                               <v-col cols="7">
                                 <v-text-field
                                   outlined
                                   label="Město"
                                   v-model="editedAddressData.city"
                                   required
                                   hide-details
                                   :rules="[rules.required]"
                                 ></v-text-field>
                               </v-col>
                               <v-col cols="5">
                                 <v-text-field
                                   outlined
                                   label="PSČ"
                                   v-model="editedAddressData.zip"
                                   required
                                   hide-details
                                   :rules="[rules.required]"
                                 ></v-text-field>
                               </v-col>
                               <v-col>
                                 <v-select
                                   required
                                   label="Městská část"
                                   :items="cityDistricts"
                                   v-model="editedAddressData.district"
                                   item-text="name"
                                   return-object
                                   hide-details
                                   :rules="[rules.required]"
                                   outlined
                                 ></v-select>
                               </v-col>
                             </v-row>
                           </v-container>
                         </v-card-text>
                         <v-card-actions class="d-flex justify-center">
                           <v-btn
                             @click="cancelEdit"
                             dark
                             color="red"
                             outlined
                             class="mr-6"
                           >
                             Zrušit
                           </v-btn>
                           <v-btn
                             @click="confirmEdit"
                             dark
                             class="btn btn-green-gradient"
                           >
                             Uložit
                           </v-btn>
                         </v-card-actions>
                       </v-form>
                      </v-card>
                    </v-dialog>

                  </v-card-text>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
    <v-container id="radio-select">
      <v-row
        class="cart-4-step"
      >
        <v-col cols="12" md="4">
          <v-radio-group
            :disabled="!!orderObject.id /* && currentUser.roleId === 6 */"
            v-model="cart.customPackaging"
            mandatory
          >
            <v-radio color="darkGreen" :value="true" label="Vlastní nádoba"></v-radio>
            <v-radio color="darkGreen" :label="`Standardní balení ${totalPackagingPrice} Kč`" :value="false"></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="12" md="4">
          <v-radio-group
            :disabled="!!orderObject.id /* && currentUser.roleId === 6 */"
            v-model="cart.deliveryType"
            mandatory
          >
            <v-radio color="darkGreen" v-if="cart.diet.dietType !== 'Instituční'" label="Osobní odběr" value="Osobní odběr"></v-radio>
            <v-radio color="darkGreen" :label="`Rozvoz ${totalDeliveryPrice} Kč`" value="Rozvoz"></v-radio>
          </v-radio-group>
        </v-col>
        <v-col
          cols="12" md="4">
          <v-radio-group v-model="cart.paymentTypeId" :disabled="!!orderObject.id" mandatory>
            <v-radio color="darkGreen" v-if="cart.diet.dietType !== 'Instituční'" :value="3" label="Hotově/Kartou při převzetí">>
            </v-radio>
            <v-radio color="darkGreen" v-if="currentUser.roleId === 6" :value="5" class="mb-0" label="Kartou online"></v-radio>
            <span style="color: red; font-size: 0.65em" class="ml-8 mb-3">Objednávku poté nelze upravit</span>
            <!-- label - prazdny string, pokud neni zvoleny uzivatel -->
            <v-radio
              color="darkGreen"
              :label="cart.user ? (cart.user.maxDebt ? 'Kredit/Dluh' : 'Kredit') : ''"
              :value="1"
            ></v-radio>
            <v-radio
              color="darkGreen"
              v-if="cart.user && cart.user.paymentTransfer"
              :value="4"
              label="Bankovním převodem"
            ></v-radio>
          </v-radio-group>
        </v-col>
        <v-col
          cols="12">
          <label class="font-weight-bold">Doplňující informace</label>
          <v-textarea
            v-model="cart.description"
            outlined
            rows="3">
          </v-textarea>
        </v-col>
      </v-row>
    </v-container>
    <div class="order-control-buttons text-right">
      <div v-if="$store.state.ordering.orderObject.id">Původní cena: {{ $store.state.ordering.orderObject.price }} Kč
      </div>
      <div class="font-weight-bold mb-4">Celkem: <span style="color: var(--v-darkGreen-base)">{{ totalOrderPrice }} Kč</span></div>
      <div
        class="d-block d-md-none"
      >
        <v-btn
          :disabled="cartEmpty || submitWait"
          :loading="submitWait"
          @click="finishOrder"
          dark
          class="btn btn-green-gradient py-7"
          block
        >
          Dokončit objednávku
        </v-btn>
        <v-btn
          @click="cancelOrder"
          dark
          block
          color="red"
          outlined
          text
          class="mr-6 mt-4"
        >
          Zrušit objednávku
        </v-btn>
      </div>
      <div
        class="d-none d-md-flex justify-space-between"
      >
        <v-btn
          @click="cancelOrder"
          dark
          color="red"
          outlined
          class="mr-6"
        >
          Zrušit objednávku
        </v-btn>
        <v-btn
          :disabled="cartEmpty || submitWait"
          :loading="submitWait"
          @click="finishOrder"
          dark
          class="btn btn-green-gradient"
        >
          Dokončit objednávku
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import rules from '@/mixins/rules'

export default {
  mixins: [rules],
  name: 'NewStep4',
  data () {
    return {
      submitWait: false,
      creditError: false,
      serverError: false,
      finishOrderLoader: null,
      cityDistricts: null,
      selectedDistrict: null,
      editDeliveryDialog: false,
      editedAddressData: {
        street: null,
        number: null,
        city: null,
        zip: null,
        district: null
      },
      editedAdress: false,
      formValid: false
    }
  },
  methods: {
    changeAddress () {
      if (this.cityDistricts === null) this.loadDistricts()
      this.editDeliveryDialog = true
    },
    cancelEdit () {
      this.editDeliveryDialog = false
      // eslint-disable-next-line no-return-assign
      Object.keys(this.editedAddressData).forEach(key => this.editedAddressData[key] = null)
    },
    confirmEdit () {
      if (!this.formValid) return
      this.editDeliveryDialog = false
      this.$store.commit('ordering/setNewDelivery', this.editedAddressData)
      this.editedAdress = true
    },
    loadDistricts () {
      this.$http.get('/city-districts')
        .then(response => {
          this.cityDistricts = this.keysToCamelCase(response.data)
        }).catch(err => console.log(err))
    },
    testovacka () {
      this.$store.commit('ordering/setBaseDeliveryPrice', 85)
    },
    cancelOrder () {
      this.reset()
      this.$emit('orderCanceled')
    },
    finishOrder () {
      if (this.submitWait) {
        return
      }
      // check if order is payable
      if (this.cart.paymentTypeId === 1) {
        const user = this.cart.user

        if (this.orderObject.id) { // editace
          const orderDiff = this.totalOrderPrice - this.orderObject.price
          if (orderDiff > 0) {
            if (user.credit + user.maxDebt < orderDiff) {
              this.creditError = true
              return
            }
          }
        } else { // vytvareni
          if (user.credit + user.maxDebt < this.totalOrderPrice) {
            this.creditError = true
            return
          }
        }
      }

      // null object
      if (!this.editedAdress) this.editedAddressData = null

      this.submitWait = true
      const options = {
        method: this.orderObject.id ? 'put' : 'post',
        url: this.currentUser.roleId === 6 ? '/orders' : '/admin/orders',
        data: this.keysToSnakeCase({
          ...this.cart,
          order: !!this.cart.order,
          price: this.totalOrderPrice,
          userId: this.cart.user.id,
          dietId: this.cart.diet.id,
          items: { ...this.cart.items },
          editedDelivery: this.editedAddressData
        })
      }
      options.url += this.orderObject.id ? '/' + this.orderObject.id : ''
      this.$emit('finishingOrder')
      this.$http(options)
        .then(response => {
          this.$emit('orderDone')
          if (this.cart.paymentTypeId === 5) {
            window.location.replace(response.data)
          }
          this.reset()
          this.updateShoppingCartStorage()
          this.goToStep(5)
          this.submitWait = false
        })
        .catch(err => {
          if (this.cart.paymentTypeId === 1 && err.response.status === 400) {
            alert('Nedostatek kreditu.')
            this.$emit('orderCanceled')
          } else {
            this.serverError = true
            // eslint-disable-next-line no-return-assign
            setTimeout(() => this.serverError = false, 3500)
          }
          this.submitWait = false
        })
    },
    ...mapMutations({
      updateCredit: 'user/updateCredit',
      goToStep: 'ordering/goToOrderingStep',
      reset: 'ordering/reset',
      updateShoppingCartStorage: 'ordering/updateShoppingCartStorage'
    })
  },
  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      cart: 'ordering/shoppingCart',
      deliveryInfo: 'ordering/deliveryInfo',
      cartEmpty: 'ordering/shoppingCartEmpty',
      totalOrderPrice: 'ordering/totalOrderPrice',
      totalDeliveryPrice: 'ordering/totalDeliveryPrice',
      totalItemsPrice: 'ordering/totalItemsPrice',
      totalPackagingPrice: 'ordering/totalPackagingPrice',
      step: 'ordering/step',
      orderObject: 'ordering/cartOrder'
    }),
    // vuex bindings
    'cart.description': {
      get () {
        return this.$store.ordering.state.cart.description
      },
      set (val) {
        this.$store.commit('ordering/setOrderDescription', val)
      }
    },
    'cart.deliveryType': {
      get () {
        return this.$store.ordering.state.cart.deliveryType
      },
      set (val) {
        this.$store.commit('ordering/setDeliveryType', val)
      }
    },
    'cart.customPackaging': {
      get () {
        return this.$store.ordering.state.cart.customPackaging
      },
      set (val) {
        this.$store.commit('ordering/setPackagingType', val)
      }
    }
  },
  watch: {
    'cart.paymentTypeId': function () {
      this.updateShoppingCartStorage()
    },
    'cart.deliveryType': function () {
      this.updateShoppingCartStorage()
    },
    'cart.customPackaging': function () {
      this.updateShoppingCartStorage()
    },
    creditError (val) {
      if (val) {
        setTimeout(() => {
          this.creditError = false
        }, 2500)
      }
    }
  },
  created () {
    if (this.cart.diet.dietType === 'Instituční' && this.cart.paymentTypeId === 3) {
      this.cart.paymentTypeId = 1
    }
    if (this.$store.state.user.user.preferredCustomPackaging === 0) {
      this.cart.customPackaging = false
    }
  }
}
</script>

<style scoped>
#last-info p {
  margin-bottom: 0 !important;
}
>>>.v-label{
  color: black !important;
  font-size: 0.9em;
}
</style>
